<template>
    <input name="valueInput[]" :value="inp">
</template>

<script>
  export default {
    name: "hiddeninput",
    props: {
      in: Object
    },
    computed: {
      inp() {
        return this.in.title +":\t"+this.in.currentColor.variant + " " + this.in.currentColor.title;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/hiddeninput.vue